// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"96a978b5","369":"753aeaee","377":"1cab05f8","434":"a300702e","536":"a4ec5ab3","660":"a88ee5c1","700":"9cd128ec"}[chunkId] + ".chunk.js";
};